import { render, staticRenderFns } from "./FormCurp.vue?vue&type=template&id=1fdb76ec"
import script from "./FormCurp.vue?vue&type=script&lang=js"
export * from "./FormCurp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports